import { Navigate, Outlet } from "react-router";

import { useAppSelector } from "../../store";
import { UserRole } from "lib/types";

const SchoolAuth = () => {
  const myRole = useAppSelector((state) => state.user.role);

  return myRole === UserRole.GUEST ? <Navigate to="/login" /> : <Outlet />;
};

export default SchoolAuth;
